import moment from "moment";
import {DEFAULT_DATE_FORMAT} from "asksuite-citrus";
import {FilterState} from "../interfaces/attendance-list-filter.interface";

export const FILTER_STATE_PRESET: FilterState = {
  companyIds: [],
  attendantIds: [],
  tagIds: [],
  channelIds: [],
  attendanceStatus: {
    opened: true,
    closed: true,
    archived: true,
  },
  messageStatus: {
    read: true,
    unread: true,
  },
  attendanceResponse: 'all',
  dateRange: {
    from: moment()
      .subtract(7, 'days')
      .startOf('day')
      .format(DEFAULT_DATE_FORMAT),
    label: 'LAST_7_DAYS',
  },
  searchInput: '',
  publicId: '',
  lastAttendanceChain: false,
  freeEntryPoint: false
};
